import { useRef } from "react";

type NavProps = {
  contactRef: React.RefObject<HTMLDivElement>;
  portfolioRef: React.RefObject<HTMLDivElement>;
  skillsRef: React.RefObject<HTMLDivElement>;
  headerRef: React.RefObject<HTMLDivElement>;
};
type ToggleProps = {
  element: HTMLElement;
  className: string;
};
function toggleState({ element, className }: ToggleProps) {
  if (!element?.classList.contains(className))
    element?.classList.add(className);
  else element?.classList.remove(className);
}

export function NavBar({
  contactRef,
  portfolioRef,
  skillsRef,
  headerRef,
}: NavProps): JSX.Element {
  const navRef = useRef<HTMLDivElement>(null);

  function checkIfIsInTop() {
    const distanceFromTop = window.scrollY;
    const menu = navRef.current;
    if (!menu) return;
    const className = "menu-scrolled";
    const alreadyHasClass = menu.classList.contains(className);
    if (distanceFromTop >= 25 && !alreadyHasClass)
      menu.classList.add(className);
    else if (distanceFromTop <= 5 && alreadyHasClass)
      menu.classList.remove(className);
  }
  document.onscroll = checkIfIsInTop;

  function toggleMenuState() {
    const menu = navRef.current;
    if (!menu) return;
    toggleState({ element: menu, className: "toggle-open" });
  }
  function scrollTo(ref: React.RefObject<HTMLDivElement>) {
    ref.current?.scrollIntoView({ behavior: "smooth" });
    toggleMenuState();
  }
  return (
    <nav ref={navRef} className="nav-container">
      <menu className="nav-menu">
        <a className="nav-link" onClick={() => scrollTo(headerRef)}>
          Home
        </a>
        <a className="nav-link" onClick={() => scrollTo(skillsRef)}>
          Skills
        </a>
        <a className="nav-link" onClick={() => scrollTo(portfolioRef)}>
          Portfolio
        </a>
        <a className="nav-link" onClick={() => scrollTo(contactRef)}>
          Contact
        </a>
      </menu>
      <button onClick={toggleMenuState} className="nav-toggle-container">
        <div className="nav-toggle-top"></div>
        <div className="nav-toggle-middle"></div>
        <div className="nav-toggle-bottom"></div>
      </button>
    </nav>
  );
}
